import React from 'react';
import { Switch } from '@/components/ui/Switch';
import type { ControllerRenderProps, FieldPath, FieldValues } from 'react-hook-form';

type SwitchInputProps = {
  field?: ControllerRenderProps<FieldValues, FieldPath<FieldValues>>;
  onInput?: (value: boolean) => void;
  disabled?: boolean;
  checked?: boolean;
  testId?: string;
};

const SwitchInput: React.FC<SwitchInputProps> = ({
  field,
  onInput,
  disabled = false,
  checked,
  testId,
}) => {
  const isChecked = checked ?? field?.value ?? false;

  return (
    <Switch
      checked={isChecked}
      onCheckedChange={(value) => {
        field?.onChange?.(value);
        onInput?.(value);
      }}
      onBlur={field?.onBlur}
      disabled={disabled}
      ref={field?.ref}
      name={field?.name}
      data-testid={testId}
    />
  );
};

export { SwitchInput };
